const IceBoxList = () => import('Views/iceBox/iceBox-list');
const IceBoxAddEdit = () => import('Views/iceBox/iceBox-addEdit');
const IceBoxDetail = () => import('Views/iceBox/iceBox-detail');

export default[
  { path: '/iceBox-list', component: IceBoxList },
  { path: '/iceBox-add', component: IceBoxAddEdit },
  { path: '/iceBox-edit/:id', component: IceBoxAddEdit },
  { path: '/iceBox-detail/:id', component: IceBoxDetail },
];



// WEBPACK FOOTER //
// ./src/router/iceBox.js